const com = {
  BLOCKED: {
    message: 'Ação não permitida. Sua empresa só possui acesso para visualizar informações',
    field: 'status',
    code: 'COM_1'
  },
  IMAGE_INVALID_FORMAT: {
    message: 'Arquivo não suportado, apenas imagens do tipo PNG e JPG são aceitos',
    field: 'image',
    code: 'COM_2'
  },
  IMAGE_TO_SMALL: {
    message: 'A imagem é muito peguena, deve ter pelo menos 48px de altura',
    field: 'image',
    code: 'COM_3'
  },
  IMAGE_EXCEEDED_SIZE: {
    message: 'A imagem excedeu o limite de tamanho',
    field: 'image',
    code: 'COM_4'
  }
};

module.exports = com;
